import TAX_IMAGE from "../assets/accounting-finance/tax_image.png";
import HR_IMAGE from "../assets/accounting-finance/tax_administration.png";

export enum sectionId {
    TAX = "TAX",
    HR = "HR",
    BUSINESS_ACCOUNTING = "BUSINESS_ACCOUNTING",
}


export interface LinkTypes {
    name: string,
    route: string,
    isActive: boolean,
    id: sectionId,
    image: any,
    heading: string,
    paragraph: string,
}

const sec_para = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Turpis vulputate at ornare sed eu " +
    "dignissim sit platea. Sodales tempus pellentesque. Lorem ipsum dolor sit amet, consectetur adipiscing " +
    "elit.Turpis vulputate at ornare sed eu dignissim sit platea. Sodales tempus pellentesque."


export const financialHelpData: Array<LinkTypes> = [
    {
        name: "Tax Registration",
        route: "#",
        isActive: true,
        id: sectionId.TAX,
        heading: 'Tax Administration Account Registration',
        paragraph: sec_para,
        image: TAX_IMAGE,
    },
    {
        name: "Hr & Payroll Management",
        route: "#",
        isActive: false,
        id: sectionId.HR,
        heading: 'Hr & Payroll Management',
        paragraph: sec_para,
        image: HR_IMAGE,
    },
    {
        name: "Business Accounting",
        route: "#",
        isActive: false,
        id: sectionId.BUSINESS_ACCOUNTING,
        heading: 'Business Accounting',
        paragraph: sec_para,
        image: TAX_IMAGE,
    },

]